import React, { useState } from "react";
import { TemplatePreviewDialogProps } from "./TemplatePreviewDialog.types";
import { useMergeAttributesTemplate } from "../../models/template/template.hooks";
import {
  appendFooter,
  mergeAttributes,
} from "../../models/template/templateUtils";
import { usePutWorkflowEmailTemplatePreviewGetQuery } from "../../app/useGeneratedApi";

export function useTemplatePreviewDialog(props: TemplatePreviewDialogProps) {
  const {
    templateId,
    campaignId,
    renderWithEjs,
    templateAttributes,
    templateData,
    templateHtml: templateHtmlProp,
    templateCss: templateCssProp,
  } = props;

  const [activeTab, setActiveTab] = useState(0);

  const templatePreviewQuery = usePutWorkflowEmailTemplatePreviewGetQuery(
    {
      id: templateId,
      templateHtml: templateId ? undefined : templateHtmlProp,
      templateCss: templateId ? undefined : templateCssProp,
    },
    {
      enabled: !!(templateId || templateHtmlProp || templateCssProp),
      refetchOnWindowFocus: false,
    }
  );

  const sourceHtml =
    templatePreviewQuery.data?.templateHtml || templateHtmlProp || "";
  const sourceCss =
    templatePreviewQuery.data?.templateCss || templateCssProp || "";

  const { templateHtml, templateCss } = useMergeAttributesTemplate(
    sourceHtml,
    sourceCss,
    templateData,
    renderWithEjs
  );

  const handleExited = () => {
    setActiveTab(0);
  };

  const html = React.useMemo(() => {
    const footer = "";
    const htmlWithPlaceholders = appendFooter(templateHtml, footer);
    return mergeAttributes(htmlWithPlaceholders, templateAttributes);
  }, [templateHtml, templateAttributes]);

  return {
    activeTab,
    setActiveTab,
    handleExited,
    html,
    css: templateCss,
    isLoading: templatePreviewQuery.isLoading,
    error: templatePreviewQuery.error?.message || null,
    refetch: templatePreviewQuery.refetch,
  };
}
